const COLORS = {
    white: '#ffffff',
    black: '#000000',
    first: '#f57c51',
    second: '#fcbc58',
    third: '#f6f8e2',
    fourth: '#e0ddca'
}

export { COLORS }